<template>
  <v-app id="inspire" :class="'route-'+$route.name" :locked="$store.state.auth.isScreenlocked ? 'true' : 'false'">
    
    <MainMenu :showMenuComplete="showMenuComplete" v-if="!$store.state.auth.isScreenlocked"/>
    <TopBar :showMenuComplete="showMenuComplete" v-if="!$store.state.auth.isScreenlocked"/>
    
    <template v-if="isNotAdmin">
      <div class="video-container" :style="isHomePage ? '' : 'opacity: 0;'">
          <video disablePictureInPicture autoplay loop muted :controls="false" id="myVideo">
              <source :src="require(`@/assets/img/lmpmatrix.mp4`)" type="video/mp4">
              Votre navigateur ne supporte pas la balise vidéo.
          </video>
      </div>
    </template>

    <!-- <template v-if="$route.meta.requiresAuth == true || $store.state.auth.isLogin">

      <template v-if="!$store.state.auth.isScreenlocked">
        <template v-if="$vuetify.breakpoint.width > 1263">
          <v-navigation-drawer v-if="$store.state.auth.isLogin" app right 
                              color="#121212" style="z-index:20;" 
                              :stateless="$store.state.app.liveMenuOpen"
                              :mini-variant="!$store.state.app.liveMenuOpen"
                              :temporary="$store.state.app.liveMenuOpen" 
                              :premanent="!$store.state.app.liveMenuOpen">
            <LiveMenu/>
          </v-navigation-drawer>
        </template>
        <template v-else>
          <v-navigation-drawer v-if="$store.state.auth.isLogin"
                              v-model="$store.state.app.liveMenuOpen"
                              :stateless="$store.state.app.liveMenuOpen"
                              app right temporary touchless
                              color="#121212" style="z-index:20;">
            <LiveMenu/>
          </v-navigation-drawer>
        </template>
      </template>
      
    </template> -->


    <v-main>
      <v-container class="pa-0" :class="isChrome() ? 'css-chrome' : ''" id="main-container" fluid>
        <router-view/>
      </v-container>
    </v-main>

    <template v-if="$store.state.auth.isLogin">
      <StatusBar/>
      <DialogMyStatus/>
      <DialogEditStatus/>
      <DialogComments/>
    </template>

    <BottomBar v-if="!$store.state.auth.isScreenlocked"/>

    <Badge v-if="appVersionName != 'wallet' && !$store.state.auth.isScreenlocked && false"></Badge>
    <Snackbar></Snackbar>
    <DialogMailDev></DialogMailDev>

    <template v-if="$vuetify.breakpoint.width > 960">
      <DialogConv :inDialog="false"/>
    </template>
    <template v-else>
      <v-dialog fullscreen v-model="$store.state.app.showDialogConv" 
                max-width="800" scrollable content-class="dialog-medium-bordered">
        <DialogConv :inDialog="true"/>
      </v-dialog>
    </template>

  </v-app>
</template>

<script>

// import LiveMenu from '@/components/main-layout/LiveMenu.vue'
import MainMenu from '@/components/main-layout/MainMenu.vue'
import TopBar from '@/components/main-layout/TopBar.vue'
import Snackbar from '@/components/main-layout/Snackbar.vue'
import DialogMailDev from '@/components/admin/DialogMailDev.vue'
import DialogConv from '@/components/main-layout/DialogConv.vue'
import Badge from '@/components/main-layout/Badge.vue'
import BottomBar from '@/components/main-layout/BottomBar.vue'
import StatusBar from '@/components/main-layout/StatusBar.vue'
import DialogMyStatus from '@/components/main-layout/DialogMyStatus.vue'
import DialogEditStatus from '@/components/map/DialogEditStatus.vue'
import DialogComments from '@/components/stream/DialogComments.vue'

import router from "@/router/router"
import io from 'socket.io-client'
//import axios from "axios"

const config = require('./config/' + process.env.NODE_ENV)

import '@/assets/css/font.css';
import '@/assets/css/app.css';

import '@/assets/css/chrome.css';

import '@/assets/css/nprogress-0.2.0.css';
// import '@/assets/css/MaterialDesign-Webfont-master/css/materialdesignicons.min.css';

let socket = null

export default {
  name: 'App',
   
  components: {
    MainMenu, TopBar, Snackbar, /*LiveMenu,*/ DialogMailDev, DialogConv, Badge, 
    BottomBar, StatusBar, DialogMyStatus, DialogEditStatus, DialogComments
  },

  data: () => ({
    showMenuComplete: true, 
    lastLang: '',
    socketIdUser: null,
    liveMenuOpen: true,
    clockLocker: null,
    isNotAdmin: false,
    isHomePage: false,
  }),

  mounted: function(){
    this.$store.dispatch('app/initLang')

    if(!this.isTheApp && this.isAndroid)
      this.$store.dispatch('app/initLinkInstallApp')
    
    //if(this.lastLang == '')
    let vueLang = localStorage.getItem("VueAppLanguage")
    if(vueLang == null) vueLang = 'fr' 
    localStorage.setItem("VueAppLanguage", vueLang)
    
    this.lastLang = vueLang ? vueLang : this.currentLangInRoute()
    setTimeout(()=>{
      if(router.currentRoute.fullPath == "/")
        router.push('/'+this.$i18n.locale)
    }, 3000)

    if(this.$store.state.auth.user._id != null)
      this.socketIdUser = this.$store.state.auth.user._id

    this.$root.$off('restartClockLocker')
              .$on('restartClockLocker', () => { 
      this.restartClockLocker()
    })
    document.addEventListener('backbutton', () => {
          //alert('back')
          // on device back button go back
          this.$router.back()
          // if in home page exit app?? navigator.app.exitApp();
    }, false)

    window.addEventListener('beforeunload', () => {
      this.$store.dispatch('auth/closeWindow') 
    });

    let isLocked = localStorage.getItem("locked")
    //alert(isLocked)
    if(isLocked == "true"){
      router.push('/screenlock')
    }
    //window.addEventListener('beforeunload', this.handleBeforeUnload);
    //localStorage.setItem("locked", false)

  },
  methods: {
    //bloquer l'écran automatiquement quand ça fait plus d'un certain temps que l'utilisateur est inactif sur son écran.
    checkScreenLock : function(){
      //console.log("CLOCK-LOCKER checkScreenLock")
      return
    },
    restartClockLocker: function(){
      if(this.clockLocker != null) clearInterval(this.clockLocker) //annule le timer précédemment lancé
      let nbSec = 2000 // this.$store.state.auth.user.lockDelay * 1000 //* 60 
      this.clockLocker = setInterval(()=>{ this.checkScreenLock()}, nbSec)
      console.log("CLOCK-LOCKER RESTARTED", nbSec, "secondes")
    },
    currentLangInRoute : function(){
      //let l = router.currentRoute.path.substr(1,2)
      return router.currentRoute.path.substr(1,2)
    },
    isChrome(){ 
      return window.chrome != null
    },
    initSocket : function(){
      console.log("#WS ??", socket)
      if(socket != null){
        console.log("#WS INIT BEFORE UNLOAD")
        window.onbeforeunload = function(){
          //console.log('emit LEAVE', this.socketIdUser)
          if(socket != null) 
            socket.emit('leave', { UID: this.socketIdUser })
        }

        socket.on('conf-connexion', () => {
          console.log("#WS connected to the socket server")
          if(this.socketIdUser != null){
            //console.log("#WS join as", this.socketIdUser)
            socket.emit('join', { UID: this.socketIdUser })
          }
        })

        socket.on('count-connected', (data) => {
            //console.log("#WS : nb connected", data)
            this.countConnected = data.count
        })

        socket.on('new-private-msg', async (data) => {
          console.log('#WS new-private-msg', data)

          if(this.$store.state.app.currentConv != null && data.newMsg.convId == this.$store.state.app.currentConv._id)
            this.$root.$emit('hot-private-message', data.newMsg)
          else{
            this.$store.dispatch('auth/newMsgInConv', data.newMsg) 
            this.$store.dispatch('app/openSnackbar', 
                                  { show: true, color:'blue', 
                                    title: "Nouveau message de <b>"+data.newMsg.senderName+"</b>",
                                    text: data.newMsg.message,
                                    icon: 'comment',
                                    dispatchAction: 'app/setShowDialogConv',
                                    dispatchParams: { show: true, conv: data.newMsg.convId },
                                    //path: '/private/' + data.newMsg.senderId + '/' + data.offerId 
                                  })
          }
        })

        socket.on('edited-private-msg', async (data) => {
          //console.log('#WS edited-private-msg', data)
          //console.log('#WS edited-private-msg', '/private/' + data.newMsg.senderId, this.$route.path)

          if(this.$route.path == '/private/' + data.newMsg.senderId + '/' + data.offerId)
            this.$root.$emit('hot-edit-private-message', data)
        })

        socket.on('deleted-private-msg', async (data) => {
          //console.log('#WS deleted-private-msg', data)
          //console.log('#WS deleted-private-msg', '/private/' + data.senderId, this.$route.path)

          if(this.$route.path == '/private/' + data.senderId + '/' + data.offerId)
            this.$root.$emit('hot-delete-private-message', data.inx)
        })

        socket.on('new-offer-paid', async (data) => {
          //console.log('#WS new-offer-paid', data)

          this.$store.dispatch('auth/refreshUserData')
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: "Paiement reçu",
                                  text: data.message,
                                  icon: 'thumb-up' })
        })

        socket.on('new-proposition', async () => {
          //console.log('#WS proposition', data)
          this.$store.dispatch('auth/refreshUserData')
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: "Nouvelle proposition reçue",
                                  text: '',
                                  path: '/propositions/seller',
                                  icon: 'thumb-up' })
        })

        socket.on('proposition-cancel', async (data) => {
          //console.log('#WS proposition', data)
          this.$store.dispatch('auth/refreshUserData')
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'amber', 
                                  title: "Proposition annulée",
                                  text: data.username+" a annulé sa proposition sur votre annonce \""+data.offerTitle+"\"",
                                  path: '/propositions/seller',
                                  icon: 'thumb-up' })
        })


        socket.on('new-answer', async () => {
          //console.log('#WS new-answer', data)
          this.$store.dispatch('auth/refreshUserData')
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: "Nouvelle réponse reçue",
                                  text: '',
                                  path: '/propositions/buyer',
                                  icon: 'thumb-up' })
        })

        socket.on('deleted-conversation', async () => {
          //console.log('#WS deleted-conversation', data)
          this.$store.dispatch('auth/refreshUserData')
        })

        socket.on('game-battle-enemy-ready', async (data) => {
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: data.playerName + " est prêt à jouer contre vous à la bataille navale !",
                                  text: '',
                                  path: '/game/battle/play/'+data.gameId,
                                  icon: 'sail-boat' })
        })

        socket.on('game-battle-new-shoot', async (data) => {
          if(this.$route.name == "game-battle-play"
          && this.$route.params.gameId == data.game._id) {
            this.$root.$emit('game-battle-new-shoot', data)
          }else{
            let target = this.numToAlpha(data.target.x) + data.target.y
            this.$store.dispatch('app/openSnackbar', 
                                  { show: true, color:'green', 
                                    title: data.playerName + " vient de lancer une attaque en " + target,
                                    text: '',
                                    path: '/game/battle/play/'+data.game._id,
                                    icon: 'sail-boat' })
          }
        })

        socket.on('send-payment-ok', async (data) => {
          console.log('#WS send-payment-ok', data)

          this.$store.dispatch('auth/refreshUserData')
          this.$root.$emit("closePopupSendMony")
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: "Paiement envoyé",
                                  text: data.message,
                                  //path: '/propositions/seller',
                                  icon: 'credit-card-check-outline' })
        })


        socket.on('receive-payment-ok', async (data) => {
          console.log('#WS receive-payment-ok', data)

          this.$store.dispatch('auth/refreshUserData')
          this.$root.$emit("closePopupReceiveMony")
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'green', 
                                  title: "Paiement reçu",
                                  text: data.message,
                                  //path: '/propositions/seller',
                                  icon: 'credit-card-check-outline' })
        })


        socket.on('status-comment-received', async (data) => {
          console.log('#WS status-comment-received', data)
          this.$store.dispatch('auth/receivedStatusComment')
          this.$root.$emit("addComments", { comment : data.data })
          this.$store.dispatch('app/openSnackbar', 
                                { show: true, color:'blue', 
                                  title: data.title,
                                  text: data.message,
                                  //path: '/propositions/seller',
                                  icon: 'comment' })
        })


        //récupérer le nombre d'utilisateurs connectés aux sockets
        this.$root.$on('get-count', () => { 
          console.log('#WS get-count')
          socket.emit('get-count')
        })
      }
    },
    testSocket : function(){
      console.log("testSocket")
      socket.emit('join', { UID: this.$store.state.auth.user._id })
    },
    numToAlpha(x){
      return  String.fromCharCode(64 + x)
    },
  },

  computed: {
    appVersionName(){ return config.appVersionName },
    isTheApp(){ return config.appAndroidVersion != null},
    isAndroid(){
      return navigator.userAgent.match(/Android/i)
    },
  },

  watch: {
    '$store.state.app.liveMenuOpen': { immediate: true, 
        async handler () {
            this.liveMenuOpen = this.$store.state.app.liveMenuOpen
        }
    },
    '$route.path': { immediate: true, 
        async handler () {
            this.showFooter = router.currentRoute.fullPath.indexOf('/admin') == -1 
            this.showMenuComplete = router.currentRoute.fullPath.indexOf('/admin') == -1 

            this.isNotAdmin = (router.currentRoute.fullPath.indexOf('/admin') == -1)
            this.isHomePage = (router.currentRoute.name == "home")

            if(this.lastLang != '' && this.lastLang != this.currentLangInRoute()){
              //this.lastLang = this.currentLangInRoute()
              //router.go()
            }
        }
    },
    '$store.state.auth.isLogin': { immediate: true, 
        handler (val, oldVal) {
            //SOCKET INITIALIZATION AFTER LOGIN CHANGE
            // console.log("#WS -- isLogin", val, 
            //                     "socketExists", socket != null, 
            //                     "auth.user._id", this.$store.state.auth.user._id)

            //user is connected
            if(val === true){
              if(socket == null){
                //console.log("#WS init connexion", config.websocketUrl)
                //memorize the user id used to join
                this.socketIdUser = this.$store.state.auth.user._id

                socket = io(config.websocketUrl, { 'transports': ['websocket'] })
                this.initSocket()
                this.restartClockLocker()
              }           
            }else{ //user has logout
              if(socket != null && this.socketIdUser != null){
                //console.log("#WS leave connexion", this.socketIdUser)
                socket.emit('leave', { UID: this.socketIdUser })
                this.socketIdUser = null
              }
            }

            if(val == false && oldVal == true) {
              console.log("redirect in APP to login")
              router.push('/login')
            }
            
        }
    },
  }, 

};
</script>
